/**
 * Validation alert for AtencionDialog
 */
import React from 'react';
import { AlertCircle } from 'lucide-react';

const AtencionValidationAlert = ({ allSolicitudesTerminado, canTerminar }) => {
  if (canTerminar) return null;

  return (
    <div className="flex items-center gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
      <AlertCircle size={18} className="text-yellow-600" />
      <p className="text-sm text-yellow-700">
        {!allSolicitudesTerminado 
          ? 'Todas las solicitudes deben estar terminadas para finalizar la atención.'
          : 'El acta de atención debe estar adjuntada o aprobada por correo.'}
      </p>
    </div>
  );
};

export default AtencionValidationAlert;
